import { Injectable } from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }
  private url = 'api/company';

  getUrl(): string {
    return this.url;
  }
}
